export default "/_next/static/images/torn-top-3-67bcead42672d543a98266ce54490df6.svg";